import React from 'react';

const Privacy = () => {
  return (
    <div className="vf-content">
      <div className="vf-grid">
        <div />
        <div>
          <h3 className="vf-text vf-text-heading--3">
            Who is responsible for the processing?
          </h3>
          <p>
            The EMBL data controller (and joint-controller if applicable)
            contact details are:
          </p>
          <p>
            EMBL-EBI Hinxton
            <br />
            Wellcome Genome Campus Hinxton, Cambridgeshire CB10 1SD United
            Kingdom
            <br />
            +44 (0)1223 494 444
            <br />
            info@ebi.ac.uk
          </p>
          <p>The EMBL Data Protection Officer's contact details are:</p>
          <p>
            EMBL Data Protection Officer
            <br />
            Email: dpo@embl.org
            <br />
            EMBL Heidelberg, Meyerhofstra\u00dfe 1, 69117 Heidelberg, Germany
          </p>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            Which is the lawful basis for processing your personal data?
          </h3>
          <p>
            Processing your personal data is necessary for our legitimate
            interest of allowing the day-to-day management, operation and
            functioning of EMBL.
          </p>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            What personal data do we process?
          </h3>
          <p>The following categories of personal data may be processed: </p>
          <p>Account & Technical Data:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item">
              Digital identifiers (username, IP address, ORCID)
            </li>
            <li className="vf-list__item">System access logs</li>
            <li className="vf-list__item">Usage data and cookie</li>
          </ul>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            For what purposes do we process your personal data?
          </h3>
          <p>
            Your personal data will be processed for the following purposes:
          </p>
          <p>Service Delivery:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">
              Provide and manage service access
            </li>
            <li className="vf-list__item ">
              Technical support and maintenance
            </li>
          </ul>
          <p>Compliance & Security:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">Data protection compliance</li>
            <li className="vf-list__item ">Security monitoring</li>
          </ul>
          <p>
            Users can use the site to create personalised profiles which are
            stored in their cookies. The purpose of the service is providing
            access to the service and support and maintenance.
          </p>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            What is the legal basis for processing?
          </h3>

          <p>
            We rely on the following legal basis(es) to process your personal
            data:
          </p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">
              The legal basis for processing is Article 6(1)(d): processing is
              necessary for EMBL's day-to-day management, operation and
              functioning.
            </li>
            <li className="vf-list__item ">
              Analytical cookies are processed based on consent (Article 6(3) of
              IP68), when the user connects to the website.
            </li>
          </ul>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            Who can access your personal data?
          </h3>
          <p>
            The following categories of recipients may access your personal
            data:{' '}
          </p>
          <p>EMBL internal recipients:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">EMBL-EBI Hinxton</li>
            <li className="vf-list__item ">Training</li>
            <li className="vf-list__item ">Web Development</li>
          </ul>
          <p>EMBL external recipients:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">
              Data processors processing data on EMBL's behalf
            </li>
            <li className="vf-list__item ">
              Data Processor 1: Google Analytics
            </li>
          </ul>
          <p>Location of Processor:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">Outside EEA, United States</li>
          </ul>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            Will your personal data be transferred to third countries (i.e.
            countries not part of EU/EAA) and/or international organisations?
          </h3>
          <p>
            There are no personal data transfers to third countries or to
            international organisations.
          </p>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            How long do we keep your personal data?
          </h3>
          <p>
            Your personal data will be kept for the following period of time:
          </p>
          <p>Retention envisaged time limits:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">
              Personal data will be retained as long as the users use the
              service
            </li>
          </ul>
          <p>Retention period rational:</p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">
              The data is kept on VMs and ITS data retention policy applies to
              this.
            </li>
          </ul>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            How do we protect your personal data
          </h3>
          <p>
            1. Risk Management & Controls: Regular risk assessments of
            information assets, Implementation of control measures,Periodic
            review of access rights
          </p>
          <p>
            2. Training & Access: Mandatory security awareness and data
            protection training, Access granted based on job roles, Strict
            management of privileged accounts, Cryptographic key management
          </p>
          <p>
            3. Incident Response & Recovery: Cyber security incident management
            process, Regular penetration testing, Disaster recovery planning,
            Business continuity measures
          </p>
          <p>
            4. Compliance & Privacy: Protection of personal data in adherence
            with IP68 and other contractual obligations, Biometric data
            security, Rigorous due diligence of third party data hosting such as
            cloud services, Regular compliance monitoring
          </p>
          <div className="vf-u-margin__top--800" />
          <h3 className="vf-text vf-text-heading--3">
            Data subjects' rights and oversight mechanism
          </h3>
          <p>
            Under Article 16 of the EMBL Internal Policy No 68, data subjects
            have the following rights:
          </p>
          <ul className="vf-list vf-list--unordered vf-list--l | vf-list--tight">
            <li className="vf-list__item ">
              a right not to be subject to a decision made by automated means
              (i.e. without any human intervention)
            </li>
            <li className="vf-list__item ">
              a right to request access to your personal data
            </li>
            <li className="vf-list__item ">
              a right to request information on the reasoning underlying data
              processing
            </li>
            <li className="vf-list__item ">
              a right to object to the processing of personal data
            </li>
            <li className="vf-list__item ">
              a right to request erasure or rectification of your personal data.
            </li>
          </ul>
          <p>
            When the legal basis to process personal data is consent, please
            note that you have the right to withdraw your consent at any time.
          </p>
          <p>
            Please note that those rights can be subject to limitations, as
            described in Article 16 (2) of the{' '}
            <a
              className="vf-link"
              href="https://www.embl.org/documents/document/internal-policy-no-68-on-general-data-protection/"
            >
              {' '}
              EMBL Internal Policy No 68.
            </a>
          </p>
          <p>
            If you wish to exercise your rights or wish to contact the data
            controller regarding any other data protection related matters, you
            can contact us using, by sending an e-mail to: info@embl.de or by
            sending a letter to: Meyerhofstraße 1 69117 Heidelberg Germany.
          </p>
          <p>
            Advice on data protection matters can also be obtained from the EMBL
            Data Protection Officer (DPO), under Article 20 (2) of the{' '}
            <a
              className="vf-link"
              href="https://www.embl.org/documents/document/internal-policy-no-68-on-general-data-protection/"
            >
              EMBL Internal Policy No 68.
            </a>{' '}
            The DPO can be reached by email at dpo@embl.org or by letter at:
            EMBL Data Protection Officer, EMBL Heidelberg, Meyerhofstraße 1,
            69117 Heidelberg, Germany.
          </p>
          <p>
            If you wish to complain under Article 25(1) of the{' '}
            <a
              className="vf-link"
              href="https://www.embl.org/documents/document/internal-policy-no-68-on-general-data-protection/"
            >
              EMBL Internal Policy No 68
            </a>
            , you may do so with the DPO by email at dpo@embl.org.
          </p>
          <p>
            If you believe that the response of the DPO is unsatisfactory or if
            the DPO has failed to respond within three months from receipt of
            the complaint, you may complain in writing to the Data Protection
            Committee. It can be reached by email at dpc@embl.org or by post at:
            EMBL Heidelberg, Data Protection Committee, Meyerhofstraße 1, 69117
            Heidelberg, Germany.
          </p>
          <div>Published at: Tuesday, November 4, 2025 - 14:00</div>
        </div>
      </div>
      <div className="vf-u-margin__top--1600" />
    </div>
  );
};

export default Privacy;
